import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { AuthProvider } from './components/AuthContext';
import AppShell from './components/AppShell';
import { localStorageFallback } from './lib/supabaseStorage';

// Set localStorage fallback initially — AppShell will replace with
// user-scoped Supabase storage after authentication
window.storage = localStorageFallback;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  </React.StrictMode>
);
